import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import juraLogoSvg from "../resources/img/Jura_Logo.svg";
import logoutSvg from "../resources/img/logoutSvg.svg";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useKeycloak } from "@react-keycloak/web";
import keycloak from "../Keycloak";
import ClipLoader from "react-spinners/ClipLoader";
import { OperatorInfo, OperatorRole, getOperatorDetails } from "../Utils/BackendInterface";
import {
  // getAddressFromDefaultArea,
  // getAvailableLayouts,
  getEmailFromKeycloakSession,
} from "../Utils/utils";

export const Dashboard = () => {
  const navigate = useNavigate();
  const [t, i18n] = useTranslation();
  const [currentUser, setCurrentUser] = useState<OperatorInfo | undefined>(undefined);

  const { keycloak, initialized } = useKeycloak();

  if (initialized && !keycloak.authenticated) {
    keycloak.login();
  }

  // Redirect to a different path
  useEffect(() => {
    if (window.location.pathname === "/dashboard") {
      navigate("userManagement");
    }

    keycloak.onAuthSuccess = () => {
      // get email from token and then query user details
      const email = getEmailFromKeycloakSession();
      if (email) {
        getOperatorDetails(email).then((operatorInfo) => {
          if (operatorInfo) setCurrentUser(operatorInfo);
          else {
            console.info("User not registered, setting undefined role");
            const unsetOperator: OperatorInfo = {
              activated: false,
              email: "",
              firstName: "",
              surname: "",
              role: OperatorRole.UNSET,
              idArea: -1,
            };
            setCurrentUser(unsetOperator);
          }
        });
      }
    };
  }, []);
  return (
    <>
      <div className="w-full h-full">
        <DashboardLayout currentUser={currentUser} />
      </div>
    </>
  );
};

export const DashboardLayout = (props: { currentUser?: OperatorInfo }) => {
  const [t, i18n] = useTranslation();
  const location = useLocation();
  return (
    <div className="w-full h-full">
      <div id="topMenu" className="w-full h-16 flex flex-col justify-center items-center">
        <div id="topMenuBar" className="flex flex-row w-11/12 h-1/2 justify-between items-center">
          <div className="flex flex-row justify-center gap-6 w-fit">
            <div
              id="userManagementButton"
              className={`text-jura-grey-font text-lg ${
                location.pathname.includes("/userManagement") ? "font-bold" : ""
              }`}
            >
              <Link to={`userManagement`}>{t("user-management")}</Link>
            </div>
            <div
              id="userManagementButton"
              className={`text-jura-grey-font text-lg ${
                location.pathname.includes("/settings") ? "font-bold" : ""
              }`}
            >
              <Link to={`settings`}>{t("settings")}</Link>
            </div>

            <img
              src={logoutSvg}
              className="w-5 fill-jura-grey-font cursor-pointer"
              onClick={() => {
                keycloak?.logout();
              }}
            />
          </div>
          <div className="flex flex-row justify-center w-fit">
            <img src={juraLogoSvg} className="w-24" />
          </div>
        </div>
      </div>
      <div id="layoutBody" className="w-full h-full-16 bg-jura-beige">
        {props.currentUser === undefined && (
          <div className="w-full pt-6 flex flex-row justify-center gap-5">
            {t("loading-user")}
            <ClipLoader loading />
          </div>
        )}

        {props.currentUser !== undefined &&
        (props.currentUser.role === OperatorRole.ADMIN ||
          props.currentUser.role === OperatorRole.MANAGER) ? (
          <Outlet context={{ currentUser: props.currentUser }} />
        ) : (
          props.currentUser !== undefined &&
          props.currentUser.role === OperatorRole.UNSET && (
            <div className="pt-10 pl-10">{t("no-operator-account-message")}</div>
          )
        )}
      </div>
    </div>
  );
};
